


export const NotFoundview = () => {


  return(
    <>404</>
  )
}